import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { t } from '@lingui/macro'
import { isInsBirthGivenPrefixAllowed } from '../lib/identity-naming'
import { PatientProfileFormData } from './usePatientProfileForm'

type UseInsBirthGivenPrefixValidationParams = {
  birthName: PatientProfileFormData['birthName']
  birthFirstName: PatientProfileFormData['birthFirstName']
  editable: boolean
  isInsEnabled: boolean
  form: UseFormReturn<PatientProfileFormData>
}

export function useInsBirthGivenPrefixValidation({
  birthName,
  birthFirstName,
  editable,
  isInsEnabled,
  form,
}: UseInsBirthGivenPrefixValidationParams) {
  const { setError, clearErrors, formState } = form
  const birthFirstNameErrorType = formState.errors.birthFirstName?.type

  useEffect(() => {
    if (!isInsEnabled || !editable || !birthName || !birthFirstName) {
      if (birthFirstNameErrorType === 'insBirthGivenPrefix') {
        clearErrors('birthFirstName')
      }
      return
    }

    const isAllowed = isInsBirthGivenPrefixAllowed(birthName, birthFirstName)
    if (!isAllowed) {
      if (birthFirstNameErrorType !== 'insBirthGivenPrefix') {
        setError('birthFirstName', {
          type: 'insBirthGivenPrefix',
          message: t`The first birth given name must match the beginning of the birth given names.`,
        })
      }
      return
    }

    if (birthFirstNameErrorType === 'insBirthGivenPrefix') {
      clearErrors('birthFirstName')
    }
  }, [birthName, birthFirstName, editable, isInsEnabled, setError, clearErrors, birthFirstNameErrorType])
}
